import { Turnstile } from '@marsidev/react-turnstile';
import { useTurnstile } from '../hooks/useTurnstile';

interface TurnstileGuardProps {
  siteKey: string;
  children: React.ReactNode;
  onVerified: (token: string) => void;
}

export function TurnstileGuard({ siteKey, children, onVerified }: TurnstileGuardProps) {
  const { isVerified, isLoading, error, onSuccess, onError, onExpire } = useTurnstile();

  const handleSuccess = (token: string) => {
    onSuccess(token);
    onVerified(token);
  };

  // Show loading state while Turnstile initializes
  if (isLoading && !isVerified) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2" />
          <p className="text-sm text-gray-500">Initializing chat...</p>
          {/* Turnstile widget - Managed mode in CF dashboard */}
          <Turnstile
            siteKey={siteKey}
            onSuccess={handleSuccess}
            onError={onError}
            onExpire={onExpire}
          />
        </div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center text-red-600">
          <p>{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // Verified - render children
  return <>{children}</>;
}
